import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getOrders as getOrdersApi,
  getSupplierOrderById as getSupplierOrderByIdApi,
  getCustomerOrders as getCustomerOrdersApi,
  addNewOrder as addNewOrderApi,
  updateOrder as updateOrderApi,
  purchaseOrder as purchaseOrderApi,
  orderShipped as orderShippedApi,
  cancelSupplierOrder as cancelSupplierOrderApi,
  cancelCustomerOrder as cancelCustomerOrderApi,
  changeOrderStatus as changeOrderStatusApi,
  offerUnits as offerUnitsApi,
} from "../../apiCalls/caller";

export const getOrders = createAsyncThunk("orders/getOrders", async (data) => {
  toast.dismiss();
  try {
    const response = getOrdersApi(data);
    return response;
  } catch (error) {
    return error;
  }
});

export const getCustomerOrders = createAsyncThunk(
  "orders/getCustomerOrders",
  async (data) => {
    toast.dismiss();
    try {
      const response = getCustomerOrdersApi(data);
      if (response.success == false) {
        toast.error("Error getting customer orders", {
          position: "top-center",
          autoClose: 3000,
        });
      }

      return response;
    } catch (error) {
      toast.error("Error getting customer orders" + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const getSupplierOrderById = createAsyncThunk(
  "orders/getSupplierOrderById",
  async (id) => {
    toast.dismiss();
    try {
      const response = getSupplierOrderByIdApi(id);
      const data = await response;

      if (data.success) {
        return response;
      }
    } catch (error) {
      toast.error("Order Failed " + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const addNewOrder = createAsyncThunk(
  "orders/addNewOrder",
  async (order) => {
    try {
      const response = addNewOrderApi(order);
      const data = await response;
      toast.success("Order Added Successfully", { autoClose: 3000 });
      return data;
    } catch (error) {
      toast.error("Order Added Failed", { autoClose: 3000 });
      return error;
    }
  }
);

export const changeOrderStatus = createAsyncThunk(
  "orders/changeOrderStatus",
  async (order) => {
    toast.dismiss();
    try {
      console.log("order", order);
      const response = changeOrderStatusApi(order);
      const data = await response;
      if (data.success) {
        toast.success("Order Status Changed Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Order Status Change Failed " + data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return data;
    } catch (error) {
      toast.error("Order Status Change Failed " + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateOrder = createAsyncThunk(
  "orders/updateOrder",
  async (order) => {
    toast.dismiss();
    try {
      const response = updateOrderApi(order);
      const data = await response;
      toast.dismiss();
      if (data.success) {
        toast.success("Order Updated Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Order Updated Failed " + data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return data;
    } catch (error) {
      toast.error("Order Updated Failed " + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const purchaseOrder = createAsyncThunk(
  "orders/purchaseOrder",
  async (order) => {
    toast.dismiss();
    try {
      const response = purchaseOrderApi(order);
      const data = await response;
      return data;
    } catch (error) {
      toast.error("Order Purchase Failed " + (error?.message || error), {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const offerUnits = createAsyncThunk(
  "orders/offerUnits",
  async (order) => {
    toast.dismiss();
    try {
      const response = offerUnitsApi(order);
      const data = await response;
      toast.success("Email sent Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Email sending Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const cancelSupplierOrder = createAsyncThunk(
  "orders/cancelSupplierOrder",
  async (order) => {
    toast.dismiss();
    try {
      const response = cancelSupplierOrderApi(order);
      const data = await response;

      toast.success("Order Cancelled Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Order Cancel Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const cancelCustomerOrder = createAsyncThunk(
  "orders/cancelCustomerOrder",
  async (order) => {
    toast.dismiss();
    try {
      const response = cancelCustomerOrderApi(order);
      const data = await response;
      toast.success("Order Cancelled Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Order Cancel Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const orderShipped = createAsyncThunk(
  "orders/shipOrder",
  async (order) => {
    toast.dismiss();
    try {
      const response = orderShippedApi(order);
      const data = await response;
      toast.success("Order Shipped Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Order Ship Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);
